import { useAppSelector } from 'state/hooks';
import { selectCurrentProjectInfo, selectWorkflow } from 'state/workflowSlice';

import { WORKFLOW_PLAN_NAMES } from 'features/nav_bar/NavBar';

export function usePageTitle() {
  const workflow = useAppSelector(selectWorkflow);
  const projectInfo = useAppSelector(selectCurrentProjectInfo);

  const title = workflow ? WORKFLOW_PLAN_NAMES[workflow] : null;
  const projectName = projectInfo?.project_name ?? null;
  const productName = import.meta.env.VITE_PRODUCT_NAME ?? 'StreetLight';

  return [title, projectName, productName].filter(Boolean).join(' | ');
}
